import React from 'react';
import { connect } from 'react-redux';
import {
  columnCode,
  columnDescription,
  columnNameLink,
  columnTools,
  columnUsers,
  columnPermissions,
  columnCategory,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleRolesSelected } from '../actions';

const RolesTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  columns = [
    columnNameLink,
    columnCode,
    columnUsers,
    columnPermissions,
    columnDescription,
    columnCategory,
    columnTools,
  ],
}) => (
  <NameDescriptionColumns
    entity="role"
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    items={items}
    columns={columns}
  >
    {hasColumn(columns, columnCategory) && (<UnsortedColumn columnId={columnCategory} />)}
    {hasColumn(columns, columnPermissions) && (<UnsortedColumn columnId={columnPermissions} />)}
    {hasColumn(columns, columnUsers) && (<UnsortedColumn columnId={columnUsers} />)}
  </NameDescriptionColumns>
);

const mapDispatchToProps = {
  onCheckBoxClick: toggleRolesSelected,
};

export default connect(null, mapDispatchToProps)(RolesTableColumns);
